// extracted by mini-css-extract-plugin
export default {"elem":"styles_elem__muPTJ","full":"styles_full__j0icK"};